import { render, staticRenderFns } from "./trendChart.mixins.vue?vue&type=template&id=da240a02"
import script from "./trendChart.mixins.vue?vue&type=script&lang=js"
export * from "./trendChart.mixins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports